import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Form, Spin } from "antd";
import { useForm } from "react-hook-form";
import { SelectField } from "../../../../atoms/FormFields";
import { CompanyListType } from "../../ducks/types";
import { useEffect } from "react";
import { getClientManagerFormList } from "../../ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  apiSubmit: (e: string) => void;
  loading: boolean;
  tableRecord: CompanyListType | null;
}

interface FormValues {
  clientManager: string;
}

export default function ChangeClientManager(props: PropsType) {
  const { onClose, apiSubmit, loading, tableRecord } = props;
  const dispatch = useAppDispatch();
  const clientManagerList = useAppSelector(
    (state) => state?.company?.companyClientManager
  );
  const {
    control,
    formState: { isDirty, isValid },
    setValue,
    handleSubmit,
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    apiSubmit(val?.clientManager);
    console.log(val);
  };

  useEffect(() => {
    dispatch(getClientManagerFormList());
  }, [dispatch]);

  useEffect(() => {
    if (tableRecord?.manager?.id) {
      setValue("clientManager", tableRecord?.manager?.id);
    }
  }, [setValue, tableRecord]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper">
          <div className="modal_header">
            <div className="title">
              <h3 style={{ marginBottom: 8 }}>Change client manager</h3>
              <p>
                Dedicated client managers have admin access to the company and
                can suspend, deactivate, or delete it.
              </p>
            </div>
          </div>

          <div className="modal_content">
            <div className="no_space">
              <SelectField
                fieldName="clientManager"
                label="Client manager"
                control={control}
                selectOption={clientManagerList}
                iProps={{
                  placeholder: "Select client manager",
                  allowClear: true,
                }}
              />
            </div>
          </div>

          <div
            className="modal_footer"
            style={{ justifyContent: "flex-start" }}
          >
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
              disabled={!isDirty || !isValid}
            >
              Save changes
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
